import React, { useEffect, useRef, useState } from "react";
import "./RoyalInternationalPopup.css";
import { useOnClickOutside, getCurrentTranslations } from "../../../utilities/helper";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    handleStateDetailsConfirmation,
    selectCreateYourHolidayStatus,
    showHideRoyalInternationalPopup,
} from "../../../features/detailsConfirmation/detailsConfirmationSlice";
import CloseIcon from "../../../assets/svgs/closeIcon.svg?react";
import { apiRequest, getUserDetails } from "../../../services/apiRequest";
import Button from "../../reusableComponents/Button/Button";
import { addToItineraryPortsData } from "../../../features/itineraryPorts/itineraryPortsSlice";
import {
    addBuildMyHolidayData,
    clearBuildMyHolidayData,
    selectBuildMyHoliday,
} from "../../../features/buildMyHoliday/buildMyHolidaySlice";
import { requestType } from "../../../services/requests";
import { setProposalInfo } from "../../../features/proposalInfo/proposalInfoSlice";
import translationResources from "../../../utilities/multiLanguage";
import { clearCreateYourHolidayData } from "../../../features/createYourHoliday/createYourHolidaySlice";

function RoyalInternationalPopup() {
    const [checkboxChecked, setCheckboxChecked] = useState(false);
    // Handle Translations
    const [translations, setTranslations] = useState({});
    useEffect(() => {
        setTranslations(translationResources["tuiBeforeStart"][window.currentLanguage]);
    }, []);
    //End ./ Handle Translations

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userDetails = getUserDetails();

    const createYourHolidayStatus = useSelector(selectCreateYourHolidayStatus);
    const buildMyHolidayData = useSelector(selectBuildMyHoliday);

    const toggleDetailsConfirmation = () => {
        dispatch(handleStateDetailsConfirmation());
    };

    const continueWithGetStarted = () => {
        dispatch(handleStateDetailsConfirmation());

        if (createYourHolidayStatus) {
            navigate("/create-your-holiday/1");
        } else {
            navigate("/get-started/1");
        }

        dispatch(clearBuildMyHolidayData());
        dispatch(clearCreateYourHolidayData());

        dispatch(addToItineraryPortsData([]));

        localStorage.setItem("buildMyHoliday", JSON.stringify(null));
        localStorage.setItem("createYourHoliday", JSON.stringify(null));
    };

    return (
        <>
            <div className="royalInternational__overlay"></div>
            <div className="royalInternational">
                <div className="royalInternational__container">
                    {/* Body */}
                    <div className="royalInternational__body">
                        {userDetails?.user_details?.country !== "NORDICS" && (
                            <div className="royalInternational__body_title">BEFORE WE GO ..</div>
                        )}

                        <div className="royalInternational__scrollable">
                            We value your privacy and are committed to protecting your personal
                            data. This privacy notice informs you about how we handle your personal
                            data, including how we share it with third parties and use it for
                            marketing purposes.
                            <br />
                            <br />
                            We collect and process the following personal data:
                            <br />
                            <ul>
                                <li>Name</li>
                                <li>Email address</li>
                            </ul>
                            <br />
                            <br />
                            By agreeing to this privacy notice, you consent to our use of your
                            personal data for marketing purposes. This includes:
                            <br />
                            <ul>
                                <li>Sending you promotional offers and updates</li>
                                <li>Personalizing your experience with our services</li>
                                <li>Conducting surveys and market research</li>
                            </ul>
                            <br />
                            <br />
                            You can opt out of marketing communications at any time by clicking the
                            "unsubscribe" link in our emails or contacting us directly.
                            <br />
                            <br />
                            By providing your personal data and agreeing to this privacy notice, you
                            consent to:
                            <ul>
                                <li>
                                    The sharing of your data with third parties as described above.
                                </li>
                                <li>The use of your data for marketing purposes.</li>
                            </ul>
                        </div>

                        <div className="royalInternational__text">
                            Please indicate your agreement by checking the box below:
                        </div>

                        <div className="royalInternational__checkboxContainter">
                            <div
                                className="royalInternational__checkbox"
                                onClick={() => {
                                    setCheckboxChecked(!checkboxChecked);
                                }}
                            >
                                {!checkboxChecked ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <rect
                                            x="0.5"
                                            y="0.5"
                                            width="23"
                                            height="23"
                                            stroke="#0050A4"
                                        />
                                        <path
                                            d="M9.54996 15.15L18.025 6.675C18.225 6.475 18.4583 6.375 18.725 6.375C18.9916 6.375 19.225 6.475 19.425 6.675C19.625 6.875 19.725 7.1125 19.725 7.3875C19.725 7.6625 19.625 7.9 19.425 8.1L10.25 17.3C10.05 17.5 9.81663 17.6 9.54996 17.6C9.2833 17.6 9.04996 17.5 8.84996 17.3L4.54996 13C4.34996 12.8 4.25413 12.5625 4.26246 12.2875C4.2708 12.0125 4.37496 11.775 4.57496 11.575C4.77496 11.375 5.01246 11.275 5.28746 11.275C5.56246 11.275 5.79996 11.375 5.99996 11.575L9.54996 15.15Z"
                                            fill="white"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <rect
                                            x="0.5"
                                            y="0.5"
                                            width="23"
                                            height="23"
                                            stroke="#0050A4"
                                        />
                                        <path
                                            d="M9.54996 15.15L18.025 6.675C18.225 6.475 18.4583 6.375 18.725 6.375C18.9916 6.375 19.225 6.475 19.425 6.675C19.625 6.875 19.725 7.1125 19.725 7.3875C19.725 7.6625 19.625 7.9 19.425 8.1L10.25 17.3C10.05 17.5 9.81663 17.6 9.54996 17.6C9.2833 17.6 9.04996 17.5 8.84996 17.3L4.54996 13C4.34996 12.8 4.25413 12.5625 4.26246 12.2875C4.2708 12.0125 4.37496 11.775 4.57496 11.575C4.77496 11.375 5.01246 11.275 5.28746 11.275C5.56246 11.275 5.79996 11.375 5.99996 11.575L9.54996 15.15Z"
                                            fill="#0BA446"
                                        />
                                    </svg>
                                )}
                            </div>
                            <p>
                                I agree to the sharing of my data with third parties and the use of
                                my data for marketing purposes.
                            </p>
                        </div>

                        <div className="royalInternational__privacyText">
                            For more information, please see our{" "}
                            <span
                                onClick={() =>
                                    window.open(
                                        "https://www.royalcaribbean.com/gbr/en/resources/privacy-policy",
                                        "_blank"
                                    )
                                }
                            >
                                privacy notice
                            </span>
                        </div>

                        <div className="royalInternational__body_buttons">
                            <Button
                                text='Get Started'
                                type={6}
                                className={`w-full !px-10 mt-5 lg:w-fit lg:mt-10 royalInternational__body_button ${!checkboxChecked && 'disabled'}`}
                                onClick={() => {
                                    dispatch(showHideRoyalInternationalPopup(false));
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RoyalInternationalPopup;
